import React, { useState } from "react";
import "./contactus.css";
import appp from "../../assets/AppPreggy.png";
import appstore1 from "../../assets/appstore1.png";
import playtore1 from "../../assets/googleplay1.png";
import axios from "axios";
import { Helmet } from "react-helmet";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    lastname: "",
    email: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      [e.target.lastname]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        "https://preggyzonewebite.preggyzone.com/backend/api/contactus",
        formData
      );
      console.log("Form Submitted:", formData);

      setSuccessMessage("Submitted Successfully ✅");
      setFormData({
        name: "",
        lastname: "",
        email: "",
        message: "",
      });

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } catch (err) {
      console.error("Error", err);
      setSuccessMessage("Submission Failed ❌");
    }
  };

  return (
    <>
      <div className="base-contact">
        <Helmet>
          <title>Contact Us - Pregnancy Tools & Resources | PreggyZone</title>
          <meta
            name="description"
            content="Whether you have questions or need support, we’re here to assist you every step of the way on your pregnancy journey."
          />
          <meta
            name="keywords"
            content="Pregnancy resources, Pregnancy guidance, Pregnancy wellness"
          />
        </Helmet>
        <div className="main-contact">
          <h1 style={{ color: "black", textTransform: "capitalize" }}>
            Contact
          </h1>
          <div id="box-contacts">
            <h2>Here to make things easier for you!</h2>
            <p style={{ color: "black" }}>
              Got something to share? We're listening! Whether you have any
              questions, suggestions, or need assistance, feel free to reach
              out. Our team is here to help!
            </p>
            <h5>Coimbatore, India | contact@preggyzone.com</h5>
          </div>

          <form className="forms" onSubmit={handleSubmit}>
            <div className="input-group">
              <div className="input-field">
                <label>First Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-field">
                <label>Last Name *</label>
                <input
                  type="text"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="input-field">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-field">
              <label>Write a message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button className="submit-buttoner-contact" type="submit">
              Submit
            </button>
            {successMessage && (
              <p
                style={{
                  color: "green",
                  marginTop: "10px",
                  fontWeight: "bold",
                  position: "absolute",
                }}
              >
                {successMessage}
              </p>
            )}
          </form>
        </div>
      </div>
      <div className="main-contact-2">
        <div id="apps">
          <img src={appp} alt="App-Preggy" />
          <div>
            <div className="d-flex justify-content-center  btn-app gap-5 box-button-contact">
              <a
                href="https://apps.apple.com/in/app/pregnancy-tracker-preggy-zone/id6451447686"
                target="_blank"
              >
                <img src={appstore1} alt="Appstore-button" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.skyraan.preggyzone"
                target="_blank"
              >
                <img src={playtore1} alt="Playstore-button" />
              </a>
            </div>
            <p
              style={{
                color: "black",
                fontWeight: "bold",
                fontSize: "20px",
                marginTop: "20px",
              }}
            >
              By SkyRaan Technologies
            </p>
          </div>
        </div>

        <div>
          <p style={{ color: "black", textAlign: "justify" }}>
            PreggyZone - Pregnancy is a life-changing experience, and we’re here
            to make sure you feel supported, informed, and empowered every step
            of the way. Our website is packed with helpful tools, like the LMP
            calculator to predict your due date, a contraction timer, and a baby
            kick count feature. We offer food suggestions, whether you're
            preparing for pregnancy or navigating each trimester, and provide
            minimal exercises to keep you fit and healthy. Plus, our trimester
            checklists, informative charts, and helpful tips ensure you're
            always in the know. We’re here to make your pregnancy journey as
            smooth and joyful as possible.
          </p>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
